import {ENV} from "../utils/constants";
import {KBUTTON_VARIANT} from "@kopjra/uikit";
import wfiLogo from "../resources/imgs/icon_webforensicsinstant.svg";

export type SolutionKey = "web-intelligence" | "web-forensics" | "web-trust" | "web-sign";
export type ForcedSolutionKey = "web-intelligence" | "web-forensics-instant" | "ltf" | "lta";

export type AreaKey = "kopjra" | "fidere" | "lti";

export const AREAS: AreaKey[] = ["kopjra", "fidere"/*, "lti"*/];

export interface Solution {
    basePrice?: number;
    modality?: "year" | "month";
    subtext?: string;
    link?: string;
    onlyCustomCTA?: boolean;
    customCTA?: {
        key: string;
        link: string;
        variant?: KBUTTON_VARIANT;
    }[]
    customLogo?: string;
    area: string;
    estimatorLink?: string;
}

export type SolutionDef = {
    [k in SolutionKey | ForcedSolutionKey]?: Solution;
};

export const forcedSolutions: ForcedSolutionKey[] = ["web-intelligence", "web-forensics-instant", "ltf", "lta"];

export const SOLUTIONS: SolutionDef = {
    "web-intelligence": {
        basePrice: 1500,
        // modality: "month",
        onlyCustomCTA: true,
        customCTA: [
            {
                key: "web-intelligence.customButtonLabel",
                link: "web-intelligence.customCTA",
            }
        ],
        area: "kopjra",
        estimatorLink: "https://estimator.kopjra.com/",
    },
    "web-forensics": {
        basePrice: 250,
        link: `https://app${(ENV && ENV !== "prod") ? `-${ENV}` : ""}.webforensics.kopjra.com`,
        area: "kopjra",
        estimatorLink: "https://estimator.kopjra.com/?answers-solution=e8c6d4a5-2781-4afb-bbce-1075f2a743a0&answers-kopjra=f6dfb134-efe9-4d90-b664-8aeb82af836e",
    },
    "web-forensics-instant": {
        onlyCustomCTA: true,
        customCTA: [
            {
                key: "web-forensics-instant.customButtonLabel",
                link: "web-forensics-instant.customCTA",
                variant: KBUTTON_VARIANT["outline-success"],
            }
        ],
        customLogo: wfiLogo,
        area: "kopjra",
        estimatorLink: "https://estimator.kopjra.com/",
    },
    // "ltf": {
    //     customLogo: ltfLogo,
    //     area: "lti",
    //     estimatorLink: "https://estimator.kopjra.com/",
    //     onlyCustomCTA: true,
    //     customCTA: [
    //         {
    //             key: "ltf.cta1Label",
    //             link: "ltf.cta1",
    //         },
    //         {
    //             key: "ltf.cta2Label",
    //             link: "ltf.cta2",
    //             variant: KBUTTON_VARIANT["outline-secondary"],
    //         },
    //     ],
    // },
    // "lta": {
    //     customLogo: ltaLogo,
    //     area: "lti",
    //     estimatorLink: "https://estimator.kopjra.com/",
    //     onlyCustomCTA: true,
    //     customCTA: [
    //         {
    //             key: "lta.ctaLabel",
    //             link: "lta.cta",
    //         },
    //     ],
    // },
    "web-trust": {
        basePrice: 600,
        modality: "year",
        link: `https://app${(ENV && ENV !== "prod") ? `-${ENV}` : ""}.webtrust.kopjra.com`,
        area: "fidere",
        estimatorLink: "https://estimator.kopjra.com/?answers-solution=afd50136-908a-4508-840f-f069ee4ee23f&answers-fidere=35e9dffa-bd3b-4482-bac5-6b5c6faed1bd",
        customCTA: [
            {
                key: "web-trust.demoCTALabel",
                link: "web-trust.demoCTALink",
                variant: KBUTTON_VARIANT["outline-secondary"],
            }
        ]
    },
    "web-sign": {
        basePrice: 15,
        modality: "month",
        link: `https://app${(ENV && ENV !== "prod") ? `-${ENV}` : ""}.websign.kopjra.com`,
        area: "fidere",
        estimatorLink: "https://estimator.kopjra.com/?answers-solution=afd50136-908a-4508-840f-f069ee4ee23f&answers-fidere=63a375ad-a590-4cce-948b-22dc2ea41f45",
    },
};
